import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import './style.css';

const MenuLink = ({ title, url }) => {
    return (
        <NavLink className="MenuLink" to={url}>
            {title}
        </NavLink>
    );
};

MenuLink.propTypes = {
    title: PropTypes.string,
    url: PropTypes.string
};

MenuLink.defaultProps = {
    title: 'Link title',
    url: '/link-path'
};

export default MenuLink;



// WEBPACK FOOTER //
// ./src/components/molecules/menuLink/index.js